import {
    IValidationMessages,
    ValidationMessagesTypes,
    InitValidationMessagesActionType,
    ChangeValidationMessageRequestActionType,
    ChangeValidationMessageFailureActionType,
    ChangeValidationMessageSuccessActionType,
} from "./types";
import { Handler } from "./../types/store-types";

const changeValidationMessageRequest: Handler<IValidationMessages, ChangeValidationMessageRequestActionType> = (
    state,
    { payload },
) => {
    return { ...state, ...payload };
};

const changeValidationMessageSuccess: Handler<
    IValidationMessages,
    ChangeValidationMessageSuccessActionType
> = state => {
    return { ...state };
};

const changeValidationMessageFailure: Handler<IValidationMessages, ChangeValidationMessageFailureActionType> = (
    state,
    { payload },
) => {
    return { ...state, ...payload };
};

const initValidationMessages: Handler<IValidationMessages, InitValidationMessagesActionType> = (state, { payload }) => {
    return { ...state, ...payload };
};

export const handlersConfigs = {
    [ValidationMessagesTypes.INIT_VALIDATION_MESSAGES]: initValidationMessages,
    [ValidationMessagesTypes.CHANGE_VALIDATION_MESSAGE_REQUEST]: changeValidationMessageRequest,
    [ValidationMessagesTypes.CHANGE_VALIDATION_MESSAGE_SUCCESS]: changeValidationMessageSuccess,
    [ValidationMessagesTypes.CHANGE_VALIDATION_MESSAGE_FAILURE]: changeValidationMessageFailure,
};
